import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupVendorCustomer } from "../../../Shared/NewForms/NFLookupVendorCustomer";
import { useTranslation } from "react-i18next";

const ClientBankRulesDetailMain = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <NFLookupVendorCustomer fieldName={"vendorCustomerId"} title={t("Vendor/Customer")} />
        </Col>
      </Row>
    </>
  );
};

export default ClientBankRulesDetailMain;
